import React, { useCallback, useState } from "react";
import { useLingui } from "@lingui/react/macro";
import TopNavLink from "./TopNavLink";
const TopNavSearchForm = React.lazy(() => import("./TopNavSearchForm"));

type Props = {
  searchUrl: string;
};

const TopNavSearch: React.FC<Props> = ({ searchUrl }) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const { t } = useLingui();

  const openSearch = useCallback(() => {
    setIsSearchOpen(true);
  }, []);

  const onRequestClose = useCallback(() => {
    setIsSearchOpen(false);
  }, []);

  return (
    <React.Fragment>
      {isSearchOpen && (
        <React.Suspense fallback={null}>
          <TopNavSearchForm
            searchUrl={searchUrl}
            onRequestClose={onRequestClose}
          />
        </React.Suspense>
      )}
      <TopNavLink
        _key="search"
        renderAs="button"
        onClick={openSearch}
        title={t({ id: "search-page-title", message: "Search" })}
        iconName="search"
        iconStrokeWidth={0.5}
      ></TopNavLink>
    </React.Fragment>
  );
};

export default TopNavSearch;
